/**
* DevExpress Dashboard (_card-data-controller.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { kpiDataController } from './_kpi-data-controller';
export class cardDataController extends kpiDataController {
    constructor(options) {
        super(options);
    }
    _iterateKpiItems(delegate) {
        var that = this;
        if (that.viewModel) {
            that.viewModel.Cards.forEach(delegate);
        }
    }
}
